import { useParams } from "react-router-dom";
import { usePhotoSeriesSearch } from "hooks/citajteo/photo_series/usePhotoSeriesSearch";
import PhotoSeriesContent from "components/common/photo_series/list/PhotoSeriesContent";
import { SEARCH_NAMES } from "constant/search/search";

export default function GroupPhotoSeries() {
  const { groupSlug, seriesType } = useParams();
  const res = usePhotoSeriesSearch({
    groupSlug,
    sType: seriesType,
    [SEARCH_NAMES.SORT_BY]: "sOrd",
    [SEARCH_NAMES.SORT_ORDER]: 1,
    [SEARCH_NAMES.LIMIT]: 100,
  });

  if (!groupSlug || !seriesType || !res) return null;

  return (
    <>
      <PhotoSeriesContent seriesLi={res.items} />
    </>
  );
}
